import { watch } from 'vue'

/** Returns whether trusted auth-session state supplies a non-empty contact identity. */
export function hasAuthenticatedAnalyticsIdentity(sessionContactId: string | null | undefined): boolean {
  return Boolean(sessionContactId?.trim())
}

/** Reads the trusted session contact without consulting the slower profile cache. */
export function readAuthenticatedAnalyticsContactId(getAuthenticatedContactId: (() => string | null) | undefined): string | undefined {
  return getAuthenticatedContactId?.() ?? undefined
}

/** Observes auth-session identity so logout cleanup cannot wait for profile-cache teardown. */
export function watchAuthenticatedAnalyticsIdentity(
  getAuthenticatedContactId: (() => string | null) | undefined,
  onIdentityChange: (contactId: string | undefined) => void
) {
  return watch(
    () => readAuthenticatedAnalyticsContactId(getAuthenticatedContactId),
    contactId => onIdentityChange(contactId),
    { immediate: true }
  )
}
